export const Urls = {
  HOME: '/',
};
